// tslint:disable
/**
 * Document generator api
 * Generate documents from templates
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface TemplateFile
 */
export interface TemplateFile {
    /**
     * 
     * @type {string}
     * @memberof TemplateFile
     */
    id: string;
    /**
     * ID of docx template file
     * @type {string}
     * @memberof TemplateFile
     */
    fileId?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFile
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFile
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFile
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFile
     */
    context: TemplateFileContextEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TemplateFileContextEnum {
    Act = 'act',
    Bill = 'bill',
    Contract = 'contract',
    EducationProtocol = 'education-protocol',
    EnrollmentOrder = 'enrollment-order',
    ExpulsionOrder = 'expulsion-order',
    FinalDocument = 'final-document'
}



